module.exports = __webpack_public_path__ + "img/primary_home.eeb8f008.svg";